enum OrderSource {
	APP = "app",
	PHONE = "phone",
	WEBSITE = "website",
	EXECUTOR = "executor",
	DISPATCHER = "dispatcher",
}

export default OrderSource;
